import React from 'react'
import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

const LoginForm = ({ onLogin }) => {
    const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Login failed");
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("user", JSON.stringify(data.user));

      onLogin(data.user, data.access_token);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

    return (
      <>
            <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#FFF7D1] to-[#FCE38A]">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-white rounded-t-lg bg-gradient-to-r from-black to-[#FFC20E]">
          <div className="flex items-center justify-center space-x-3">
            <div className="p-2 bg-white border-2 border-[#FFC20E] rounded-lg">
              <img src="/logo.png" alt="CWC Logo" className="w-auto h-12" />
            </div>

            <div className="text-center">
              <CardTitle className="text-2xl">WAKEBOARD REGISTRATION</CardTitle>
              <CardDescription className="text-yellow-100">
                Point of Sale System
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials({ ...credentials, username: e.target.value })
                }
                required
                placeholder="Enter your username"
                className="focus-visible:ring-[#FFC20E] focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none focus:border-[#FFC20E]"
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) =>
                  setCredentials({ ...credentials, password: e.target.value })
                }
                required
                placeholder="Enter your password"
                className="focus-visible:ring-[#FFC20E] focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none focus:border-[#FFC20E]"
              />
            </div>

            {error && (
              <Alert className="border-red-500 bg-red-50">
                <AlertDescription className="text-red-700">
                  {error}
                </AlertDescription>
              </Alert>
            )}

            <Button
              type="submit"
              className="w-full bg-[#FFC20E] hover:bg-[#E0A800] text-black"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="flex items-center space-x-2">
                  <div className="w-4 h-4 border-b-2 border-black rounded-full animate-spin"></div>
                  <span>Signing in...</span>
                </div>
              ) : (
                "Sign In"
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
      </>
    )
}

export default LoginForm;